import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layout'

/**
 * 公共路由
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login')
  },
  {
    path: '/register',
    component: () => import('@/views/register')
  },
  {
    path: '/password-reset',
    component: () => import('@/views/password-reset')
  },
  {
    path: '/terms',
    component: () => import('@/views/terms')
  },
  {
    path: '/',
    component: () => import('@/views/client/index'),
    hidden: true
  },
  {
    path: '/search/:searchContent',
    component: () => import('@/views/client/search'),
    hidden: true,
    meta: { title: '搜索' }
  },
  {
    path: '/collect',
    component: () => import('@/views/client/collect'),
    hidden: true,
    meta: { title: '最新收录' }
  },
  {
    path: '/about',
    component: () => import('@/views/client/about'),
    hidden: true,
    meta: { title: '关于本站' }
  },
  {
    path: '/software-trade',
    component: () => import('@/views/soft/nav-soft'),
    hidden: true,
    meta: { title: '软件交易市场' }
  },
  {
    path: '/plug-in',
    component: () => import('@/views/client/plug-in'),
    hidden: true,
    meta: { title: '插件下载' }
  },
  {
    path: '/log',
    component: () => import('@/views/client/log'),
    hidden: true,
    meta: { title: '更新日志' }
  },
  {
    path: '/guide',
    component: () => import('@/views/client/guide'),
    hidden: true,
    meta: { title: '使用指南' }
  },
  {
    path: '/jy',
    component: () => import('@/views/client/simple'),
    hidden: true,
    meta: { title: '简约版' }
  },
  {
    path: '/jy-self',
    component: () => import('@/views/client/simple-self'),
    hidden: true,
    meta: { title: '自定义简约版' }
  },
  {
    path: '/workbench-self',
    component: () => import('@/views/client/workbench-self'),
    hidden: true,
    meta: { title: '工作台导航' }
  },
  {
    path: '/setIndex',
    component: () => import('@/views/client/set-index'),
    hidden: true,
    meta: { title: '设为首页' }
  },
  {
    path: '/client/soft',
    component: () => import('@/views/client/soft/index'),
    hidden: true,
    meta: { title: '软件交易市场' }
  },
  {
    path: '/client/soft/add',
    component: () => import('@/views/client/soft/components/SoftAdd'),
    hidden: true,
    meta: { title: '软件登记提交' }
  },
  {
    path: '/client/soft/detail/:id',
    component: () => import('@/views/client/soft/components/SoftDetail'),
    hidden: true,
    meta: { title: '软件详情' }
  },
  {
    path: '/client/soft/my',
    component: () => import('@/views/client/soft/my'),
    hidden: true,
    meta: { title: '我的软件提交' }
  },
  {
    path: '/me',
    component: () => import('@/views/client/me'),
    hidden: true,
    meta: { title: '我的导航' }
  },
  {
    path: '/favorites',
    component: () => import('@/views/client/favorites'),
    hidden: true,
    meta: { title: '收藏夹网站' }
  },
  {
    path: '/favorites/index',
    component: () => import('@/views/nav/favorites/site'),
    hidden: true,
    meta: { title: '收藏夹网站' }
  },
  {
    path: '/share/:shareUrl',
    component: () => import('@/views/client/share'),
    hidden: true
  },
  {
    path: '/nav/edit',
    component: () => import('@/views/nav/user/edit'),
    hidden: true,
    meta: { title: '自定义导航' }
  },
  {
    path: '/index',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: '',
        component: () => import('@/views/index'),
        name: 'Index',
        meta: { title: '首页', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'profile',
        component: () => import('@/views/system/user/profile'),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user' }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/403',
    component: () => import('@/views/error/403'),
    hidden: true
  }
]

/**
 * 动态路由，基于用户权限动态去加载
 */
export const dynamicRoutes = [
  {
    path: '/system/role-auth',
    component: Layout,
    hidden: true,
    permissions: ['system:role:authUser'],
    children: [
      {
        path: 'user/:id',
        component: () => import('@/views/system/role/authUser'),
        name: 'AuthUser',
        meta: { title: '分配用户角色', activeMenu: '/system/role' }
      }
    ]
  },
  {
    path: '/system/api/data/',
    component: Layout,
    hidden: true,
    permissions: ['system:api:page'],
    children: [
      {
        path: ':id',
        component: () => import('@/views/system/api'),
        name: 'APIData',
        meta: { title: 'API 接口数据', activeMenu: '/system/api' }
      }
    ]
  },
  {
    path: '/system/dictionary/data',
    component: Layout,
    hidden: true,
    permissions: ['system:dictionary:data:page'],
    children: [
      {
        path: ':id',
        component: () => import('@/views/system/dictionary/data'),
        name: 'DictionaryData',
        meta: { title: '字典数据', activeMenu: '/system/dictionary' }
      }
    ]
  },
  {
    path: '/system/nav/edit',
    component: () => import('@/views/nav/edit'),
    hidden: true,
    permissions: ['nav:category:site:edit'],
    meta: { title: '系统导航编辑' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: constantRoutes
})

export default router
